import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useConditionalFormattingEntryPoint } from '@atlassian/jira-issue-navigator-action-conditional-formatting/src/controllers/entrypoint-context/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { ErrorState } from '../error-state/index.tsx';

type Props = {
	onClose: () => void;
};

function ConditionalFormattingSidebarExperience({ onClose }: Props) {
	const { entryPointReferenceSubject } = useConditionalFormattingEntryPoint();

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="conditionalFormattingSidebar"
			packageName="jiraIssueNavigatorActionConditionalFormatting"
			errorFallback={() => <ErrorState onClose={onClose} />}
			teamName="Keystone"
			fallback={<></>}
			runtimeProps={{ message: 'Hello world!', onClose }}
		/>
	);
}

export const MaybeConditionalFormattingSidebarExperience = componentWithCondition(
	() => fg('conditional-formatting-new-list-targeting-gate'),
	ConditionalFormattingSidebarExperience,
	() => <></>,
);
